import PropTypes from 'prop-types'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import {styled} from '@mui/material/styles'
import {StyledTextField} from '../../AdminPanelStyling'

const StyledCounterTypography = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'isLimitBreached'
})(({isLimitBreached, theme}) => ({
  marginTop: theme.spacing(0.5),
  textAlign: 'left',
  color: isLimitBreached ? theme.palette.error.main : theme.palette.text.secondary
}))

const TextAreaWithCounter = ({
  value,
  onChange,
  label,
  maxLength,
  error,
  helperText,
  disabled,
  fullWidth,
  size,
  minRows,
  name,
  textAreaProps
}) => {
  const currentLength = value.length
  const isLimitBreached = currentLength > maxLength

  return (
    <Box display='flex' flexDirection='column' alignItems='stretch'>
      <StyledTextField
        multiline
        minRows={minRows}
        value={value}
        onChange={onChange}
        label={label}
        name={name}
        fullWidth={fullWidth}
        size={size}
        error={error}
        helperText={helperText}
        disabled={disabled}
        {...textAreaProps}
      />
      <StyledCounterTypography
        variant='caption'
        isLimitBreached={isLimitBreached}
        data-testid='textarea-char-counter'
        data-overlimit={isLimitBreached ? 'true' : 'false'}
      >
        {`${currentLength}/${maxLength}`}
      </StyledCounterTypography>
    </Box>
  )
}

TextAreaWithCounter.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  maxLength: PropTypes.number,
  error: PropTypes.bool,
  helperText: PropTypes.node,
  disabled: PropTypes.bool,
  fullWidth: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'medium']),
  minRows: PropTypes.number,
  name: PropTypes.string,
  textAreaProps: PropTypes.object
}

TextAreaWithCounter.defaultProps = {
  label: '',
  maxLength: 100,
  error: false,
  helperText: '',
  disabled: false,
  fullWidth: true,
  size: 'medium',
  minRows: 4,
  name: undefined,
  textAreaProps: {}
}

export default TextAreaWithCounter
